import React from 'react';
import ContactSection from '../sections/ContactSection';

export default function ContactPage({ contact }) {
  return <ContactSection contact={contact} />;
}
